/*
 * This is ONLY for widgets who's widgetType do
 * not match the Zignal Widgets import name
 */

export default {
  TotalMentionsChartbyIssue: 'TotalMentionsChartByIssue',
  ScoreOverTimeWidget: 'MediaQualityScoreOverTime',
  SentimentPieChart: 'SentimentBreakdown',
  SentimentSmallGaugeChart: 'NetSentiment',
  ImpactScoreBarChart: 'ImpactScore',
  NetShareOfVoicePieChart: 'ShareOfVoicePieChart',
  InfluentialSitesByMentions: 'TopSitesByMentions',
  InfluentialSitesByShares: 'TopSitesByShares',
};
